export const LINE_TYPE_URL = `/orp/bfe/api/portal-service/subscriber/line-type`;
export const FETCH_CONFIGURATION = `/orp/bfe/api/portal-service/resource/v1/get-product-config`;
export const GET_OTP_URL = "/orp/bfe/api/portal-service/optimus/otp/send";
export const GET_INVOICE_DETAIL = "/orp/bfe/api/portal-service/subscriber/getopeninvoice";
export const RESEND_OTP_URL = "/orp/bfe/api/portal-service/optimus/otp/resend";
export const VERIFY_OTP_URL = "/orp/bfe/api/portal-service/optimus/otp/verify";
export const VALIDATE_MSIDN_ACCOUNT_URL = "/orp/bfe/api/portal-service/subscriber/validate/msisdn-account"
export const FETCH_BILL_URL = "/orp/bfe/api/portal-service/subscriber/v1/bill";
export const GET_BUNDLE_URL = "/orp/bfe/api/portal-service/product/v1/bundle";
export const PAYMENT_OPTIONS = "/orp/bfe/api/portal-service/transaction/v1/payment-options";
export const INTIATE_PAYMENT = '/orp/bfe/api/portal-service/transaction/v1/initiate';
export const PROCESS_TRXN = '/orp/bfe/api/portal-service/transaction/v1/process';
export const GET_OTP_V1 = "/orp/bfe/api/portal-service/otp/v1/send-otp";
export const VERIFY_OTP_V1 = '/orp/bfe/api/portal-service/otp/v1/verify-otp';
export const GET_QUERY_BALANCE = "/orp/bfe/api/portal-service/subscriber/v4/query-balance";
export const CHECK_AM_STATUS = "/orp/bfe/api/portal-service/transaction/v1/status?tid=";
export const RESEND_OTP_V1 = "/orp/bfe/api/portal-service/otp/v1/resend-otp";
export const FETCH_PAYMENT_STATUS = "/orp/bfe/api/portal-service/transaction/fetch?txnId=";
export const EXCHANGE_RATES = "/orp/bfe/api/portal-service/transaction/get/exchange/rate";
export const PAYMENT_OPTIONS_AW = "/orp/bfe/api/portal-service/transaction/payment-options";
export const LEAD_SUBMIT = `/orp/bfe/api/portal-service/subscriber/v1/submit-lead`;
export const VERIFY_OTP_AND_AM_USER = `/auth/bfe/api/portal-service/otp/v1/verify-user`;
export const INTIATE_PAYMENT_AM_PIN = `/orp/bfe/api/portal-service/transaction/v1/auth/initiate`;
export const PROCESS_TRXN_AM_PIN = `/orp/bfe/api/portal-service/transaction/v1/auth/process`;
export const CHECK_BROADBAND_AND_LINKED_DEVICE = "/orp/bfe/api/portal-service/subscriber/v1/check-broadband-and-linked-device";
export const SUCCESS = "success";
export const KE = "KE";
export const PG = "PG";
export const AM = "AM";
export const LEAD_STATUS = `/orp/bfe/api/portal-service/subscriber/v1/track-lead`;
export const SEND_HBB_OTP = `/orp/bfe/api/portal-service/subscriber/v1/send-otp-hbb`;
export const PAYMENT_MODE_SMARTCASH = "SMARTCASH_SECURE"
export const PAYMENT_MODE_AM = "AIRTEL_MONEY"
export const PAYMENT_OPTIONS_V3 = "/orp/bfe/api/portal-service/transaction/payment-options";
export const GA = "ga"
export const ORP = "ORP"
export const SAVE_FORM = "api/portal-service/form/v2/save"
export const AW_TRANSACTION_TYPE = "HBB LEADS"
export const SMARTCASH = "SMARTCASH"
export const AIRTEL_MONEY = "AIRTEL_MONEY";
export const AIRTEL_MONEY_PUSH = "AIRTEL_MONEY_PUSH";
export const BUNDLE_PURCHASE = "BUNDLE_PURCHASE"
export const AIRTIME_RECHARGE = "AIRTIME_RECHARGE"
export const AIRTEL_WEBSITE = "Airtel Website"
export const HOME = "Home"
export const TXN_NOT_FOUND_STATUS_CODE = "7003"
export const GaCurrency = "CFA"
export const UNIFIED_PAYMENT_OPTIONS = "/api/portal-service/payment/v3/payment-options";


